/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_2fa_SecretInputs */

const cs_settings_profile_2fa_secret = /** @type {(inputs: Settings_Profile_2fa_SecretInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tajný klíč`)
};

const en_settings_profile_2fa_secret = /** @type {(inputs: Settings_Profile_2fa_SecretInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secret`)
};

/**
* | output |
* | --- |
* | "Secret" |
*
* @param {Settings_Profile_2fa_SecretInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_profile_2fa_secret = /** @type {((inputs?: Settings_Profile_2fa_SecretInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_2fa_SecretInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_profile_2fa_secret(inputs)
	return cs_settings_profile_2fa_secret(inputs)
});